export default "__VITE_ASSET__C34DsJy2__"